import { render, staticRenderFns } from "./right_blue.vue?vue&type=template&id=2f810198&scoped=true"
import script from "./right_blue.vue?vue&type=script&lang=js"
export * from "./right_blue.vue?vue&type=script&lang=js"
import style0 from "./right_blue.vue?vue&type=style&index=0&id=2f810198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f810198",
  null
  
)

export default component.exports